import { Component, OnInit, AfterViewInit, OnChanges, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
import { GruaMotiusDesestimarFilterService } from '../../services/grua-motius-desestimar-filter.service';
import { GruaMotiusDesestimarFilter } from '../../models/grua-motius-desestimar-filter';
import { GruaMotiusDesestimarService } from '../../services/grua-motius-desestimar.service';
import { MotiusDestimacioGrua } from 'app/sections/grua/Models/motius-desestimacio.model';


@Component({
  selector: 'app-grua-motius-desestimar-table',
  templateUrl: './grua-motius-desestimar-table.component.html',
  styleUrls: ['./grua-motius-desestimar-table.component.scss']
})
export class GruaMotiusDesestimarTableComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: MotiusDestimacioGrua[];
  dataSource: CustomDataSource<MotiusDestimacioGrua, GruaMotiusDesestimarFilter>;
  filter: GruaMotiusDesestimarFilter = new GruaMotiusDesestimarFilter('motiu', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() updatedFilterData: GruaMotiusDesestimarFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['id', 'motiu'];

  constructor(
    private gruaMotiusDesestimarService: GruaMotiusDesestimarService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<MotiusDestimacioGrua, GruaMotiusDesestimarFilter>(this.paginator, new GruaMotiusDesestimarFilterService(), 'urlGetGruaMotiusDesestimar', 'urlGetGruaMotiusDesestimarCount');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        this.filterService.saveFilter('grua-motius-desestimar-filter', this.filter);
      }
    });

    this.filterService.loadFilter('grua-motius-desestimar-filter', this.filter);
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.secureId);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.gruaMotiusDesestimarService, filter, this.i18n('Motius desestimació'), this.sort.direction, this.sort.active)
    });
  }

}
